import { CustomBottomBar } from '@components';
import { Button, Container, Typography } from '@design-system';
import { useWithdrawalPageVM } from './useWithdrawalPageVM';
import './WithdrawalPage.scss';

export const WithdrawalPage: React.FC = () => {
    const { handleNext } = useWithdrawalPageVM();

    return (
        <div className="withdrawal-page">
            <Container>
                <Typography intrinsic="h2" className="mb-medium-spacing">
                    Droit d'alerte et de retrait
                </Typography>

                <Container className="information-container mb-medium-spacing" bordered="grey" padding="medium large">
                    <Typography intrinsic="h3" className="mb-small-medium-spacing">
                        Le devoir d'alerte
                    </Typography>
                    <Typography intrinsic="p">
                        Le devoir d'alerte vous permet d'alerter votre employeur au sujet de toute situation de travail pouvant présenter un
                        danger grave et imminent pour leur vie ou leur santé ou tout manquement constaté dans les systèmes de protection.
                    </Typography>
                </Container>

                <Container className="information-container mb-medium-spacing" bordered="grey" padding="medium large">
                    <Typography intrinsic="h3" className="mb-small-medium-spacing">
                        Le droit de retrait
                    </Typography>
                    <Typography intrinsic="p">
                        Je stoppe ou je fais stopper toute activité si je constate un risque non maîtrisé pour un ou plusieurs intervenants
                        : j'exerce mon devoir de retrait pour moi et mes collègues.
                    </Typography>
                </Container>
            </Container>

            <CustomBottomBar>
                <Button variant="primary" color="marine" size="fullwidth" disabled={false} onClick={handleNext}>
                    <Typography intrinsic="h4">Suivant</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
